module.exports = "/build/images/voiture.bfc97630.jpg";